/**
 * Isolated interaction script for the consolidated "Sunfade Hoodie"
 * master product page. Only loaded by
 * sections/main-product-sunfade-hoodie.liquid, which is only ever
 * rendered for one product (id 10343401521443). Safe to delete along
 * with that section, its template, CSS, and this file.
 *
 * Selecting a color swap the visible gallery block (no page reload) and
 * re-points both purchase buttons at the real Shopify variant matching
 * the current color + size, exactly like the single-color Wait & Save
 * build. Each button always submits a real variant id, so the price
 * charged at checkout is always that variant's actual stored price.
 */
(function () {
  var BULLET = String.fromCharCode(8226);
  var MIDDOT = String.fromCharCode(183);

  function initRoot(root) {
    var sectionId = root.dataset.sectionId;
    var productTitle = root.dataset.sfProductTitle || 'Sunfade';
    var wrapper = root.closest('.js-product');
    if (!wrapper) return;

    var dataEl = document.getElementById('sf-data-' + sectionId);
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var readyForm = wrapper.querySelector('#' + sectionId + '-ready form.js-product-form');
    var waitForm = wrapper.querySelector('#' + sectionId + '-wait form.js-product-form');
    if (!readyForm || !waitForm) return;

    var readyFormWrapper = readyForm.closest('product-form') || readyForm;
    var waitFormWrapper = waitForm.closest('product-form') || waitForm;
    var productMode = root.dataset.sfPurchaseMode || '';

    var readyIdInput = readyForm.querySelector('[data-sf-ready-input]');
    var readySubmit = readyForm.querySelector('[data-sf-ready-submit]');
    var readyMain = readyForm.querySelector('[data-sf-ready-main]');
    var readyStatus = readyForm.querySelector('[data-sf-ready-status]');
    var readyStatusText = readyStatus ? readyStatus.lastChild : null;

    var waitIdInput = waitForm.querySelector('[data-sf-wait-input]');
    var waitSubmit = waitForm.querySelector('[data-sf-wait-submit]');
    var waitMain = waitForm.querySelector('[data-sf-wait-main]');

    var mainPrice = wrapper.querySelector('[data-sf-price-main-value]');
    var mainPriceWrap = wrapper.querySelector('[data-sf-price-wrap]');
    var mainPriceWas = wrapper.querySelector('[data-sf-price-was]');
    var mainPriceWasValue = wrapper.querySelector('[data-sf-price-was-value]');
    var savingsBadges = wrapper.querySelectorAll('[data-sf-savings]');
    var savingsAmount = wrapper.querySelector('[data-sf-savings-amount]');
    var savingsPercent = wrapper.querySelector('[data-sf-savings-percent]');
    var colorNameEl = wrapper.querySelector('[data-sf-color-name]');
    var swatches = wrapper.querySelectorAll('[data-sf-swatch]');
    var sizeRadios = wrapper.querySelectorAll('[data-sf-size]');
    var galleries = document.querySelectorAll('[data-sf-gallery-for]');
    var soldoutBlock = wrapper.querySelector('[data-sf-soldout]');

    function findVariant(color, size, type) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.color === color && v.size === size && v.type === type) return v;
      }
      return null;
    }

    function getSelectedColor() {
      var selected = wrapper.querySelector('.sf-swatch--selected');
      return selected ? selected.getAttribute('data-sf-swatch') : (variants[0] && variants[0].color);
    }

    function getSelectedSize() {
      var checked = wrapper.querySelector('[data-sf-size]:checked');
      return checked ? checked.value : (variants[0] && variants[0].size);
    }

    function selectColor(color) {
      swatches.forEach(function (btn) {
        var isSelected = btn.getAttribute('data-sf-swatch') === color;
        btn.classList.toggle('sf-swatch--selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      if (colorNameEl) colorNameEl.textContent = color;
      galleries.forEach(function (gallery) {
        var matches = gallery.getAttribute('data-sf-gallery-for') === color;
        gallery.hidden = !matches;
      });
    }

    function update() {
      var color = getSelectedColor();
      var size = getSelectedSize();
      var readyVariant = findVariant(color, size, 'ready');
      var waitVariant = findVariant(color, size, 'wait');

      // Purchase Mode (Ready to Ship / Wait & Save visibility control) -
      // never touches the underlying variant/price data, only which of
      // the two real purchase paths are shown for this color + size.
      // Priority: variant-level override -> product-level default ->
      // "Both" (Sunfade's existing, unchanged behavior when nothing is
      // configured).
      var modeOverride = (readyVariant && readyVariant.modeOverride) || (waitVariant && waitVariant.modeOverride) || '';
      var effectiveMode = modeOverride || productMode || 'Both';
      var readyModeAllowed = effectiveMode === 'Both' || effectiveMode === 'Ready to Ship Only';
      var waitModeAllowed = effectiveMode === 'Both' || effectiveMode === 'Wait & Save Only';

      // Use an explicit style (not the hidden attribute) since
      // ".hw-buttons product-form { display: block }" in main.css
      // otherwise outranks the browser's built-in [hidden] rule.
      if (readyFormWrapper) readyFormWrapper.style.display = readyModeAllowed ? '' : 'none';
      if (waitFormWrapper) waitFormWrapper.style.display = waitModeAllowed ? '' : 'none';

      var readyAvailable = readyModeAllowed && !!(readyVariant && readyVariant.available);
      if (readyIdInput) {
        readyIdInput.value = readyVariant ? readyVariant.id : '';
        readyIdInput.disabled = !readyVariant;
      }
      if (readySubmit) readySubmit.disabled = !readyAvailable;
      if (readyMain) {
        readyMain.textContent = readyVariant
          ? (readyAvailable ? ('Add to Cart ' + BULLET + ' ' + readyVariant.priceFormatted) : 'Sold Out')
          : 'Unavailable';
      }
      if (readyStatusText) {
        readyStatusText.textContent = readyAvailable ? ('In Stock ' + MIDDOT + ' Ready to Ship') : 'Sold out for this size';
      }
      if (mainPrice && readyVariant) mainPrice.textContent = readyVariant.priceFormatted;

      // Compare-at price - the main price area always reflects Ready to
      // Ship (the purchase cards below show their own clean prices), so
      // it's driven from readyVariant specifically, real Shopify data
      // only, never invented or left stale from a previous color/size.
      if (readyVariant) {
        var isOnSale = typeof readyVariant.compareAtPrice === 'number' && readyVariant.compareAtPrice > readyVariant.price;
        if (mainPriceWrap) mainPriceWrap.classList.toggle('price--on-sale', isOnSale);
        if (mainPriceWas) mainPriceWas.hidden = !isOnSale;
        if (mainPriceWasValue) mainPriceWasValue.textContent = isOnSale ? readyVariant.compareAtFormatted : '';

        // "Save $X X% off" - always the Ready to Ship price's own retail
        // savings, never the separate Wait & Save incentive shown in the
        // pre-order button below.
        savingsBadges.forEach(function (badge) { badge.hidden = !isOnSale; });
        if (savingsAmount) savingsAmount.textContent = isOnSale ? readyVariant.retailSavingsFormatted : '';
        if (savingsPercent) savingsPercent.textContent = isOnSale ? readyVariant.retailSavingsPercent : '';
      }

      var waitAvailable = waitModeAllowed && !!(waitVariant && waitVariant.available);
      if (waitIdInput) {
        waitIdInput.value = waitVariant ? waitVariant.id : '';
        waitIdInput.disabled = !waitVariant;
      }
      if (waitSubmit) waitSubmit.disabled = !waitAvailable;
      if (waitMain && waitVariant) {
        if (!waitAvailable) {
          waitMain.textContent = 'Sold Out';
        } else if (waitVariant.savingsFormatted && readyVariant) {
          waitMain.textContent = '';
          waitMain.appendChild(document.createTextNode('Pre-Order ' + BULLET + ' '));
          var strike = document.createElement('s');
          strike.textContent = readyVariant.priceFormatted;
          waitMain.appendChild(strike);
          waitMain.appendChild(document.createTextNode(' ' + waitVariant.priceFormatted));
        } else {
          waitMain.textContent = 'Pre-Order ' + BULLET + ' ' + waitVariant.priceFormatted;
        }
      } else if (waitMain) {
        waitMain.textContent = 'Sold Out';
      }

      // STATE 4: both Ready to Ship and Wait & Save are unavailable for
      // this exact color + size - hide both purchase buttons and show a
      // single Sold Out / Notify When Available block instead. States
      // 1-3 (at least one option purchasable) keep using the two normal
      // buttons above, each already reflecting its own available/sold
      // out state.
      var bothUnavailable = !readyAvailable && !waitAvailable;
      root.hidden = bothUnavailable;
      if (soldoutBlock) soldoutBlock.hidden = !bothUnavailable;

      if (bothUnavailable && window.NotifyWhenAvailable) {
        var notifyVariant = readyVariant || waitVariant;
        window.NotifyWhenAvailable.setContext({
          productTitle: productTitle,
          lines: ['Color: ' + color, 'Size: ' + size],
          variantId: notifyVariant ? notifyVariant.id : ''
        });
      }
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectColor(btn.getAttribute('data-sf-swatch'));
        update();
      });
    });

    sizeRadios.forEach(function (radio) {
      radio.addEventListener('change', update);
    });

    // If the customer picked a color from a product card (Shop All,
    // homepage, search, etc.) before clicking through, the card links
    // to this page with ?Color=<name> - honor it so the PDP opens
    // already showing that color instead of always defaulting back to
    // the first one.
    var urlColor = new URLSearchParams(window.location.search).get('Color');
    if (urlColor && variants.some(function (v) { return v.color === urlColor; })) {
      selectColor(urlColor);
    }

    update();
  }

  function init() {
    document.querySelectorAll('[data-sf-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
